import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page53() {
  useEffect(() => {
    document.title = "Маяк — Страница 52"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page51" />
        <ForwardLink href="/page53" />
      </div>

      <p style={{ textAlign: "right" }}>52.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Что?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Что значит "что"?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Недели?
      </p>
      <p>МОЛОДОЙ начинает теряться, бояться.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Недели, да. Недели.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Мы спали. Смертельно пьяные.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Прошли недели с тех пор, как мы пропустили<br/>
        его, Уинслоу. И я уже несколько<br/>
        недель просил тебя экономить пайки,<br/>
        а ты продолжал лаять на меня как<br/>
        бешеный пес, говоря, что ты можешь “спустить<br/>
        дори (спасательную лодку)”--
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Теперь послушайте--
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Не теряй голову сейчас.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Это уже не смешно.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Нет, это не смешно. И я не хочу<br/>
        застрять здесь с каким-то<br/>
        сумасшедшим.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Застрять?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Я так и сказал.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я думал, Вы сказали, что придет<br/>
        сменщик.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Если мы сможем переждать этот шторм.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Тендер уже в пути.
      </p>
      <p style={{ textAlign: "right" }}>52.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page51" />
        <ForwardLink href="/page53" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710630678/the-lighthouse-script/mypwkzpb7gjudomzzls7.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page53;
